var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2612_19612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5455 0.826172H1.79755C0.803668 0.826172 0 1.61082 0 2.58093V23.4145C0 24.3846 0.803668 25.174 1.79755 25.174H22.5455C23.5394 25.174 24.3478 24.3846 24.3478 23.4192V2.58093C24.3478 1.61082 23.5394 0.826172 22.5455 0.826172ZM7.22351 21.5741H3.60938V9.95185H7.22351V21.5741ZM5.41644 8.36829C4.25611 8.36829 3.31929 7.43147 3.31929 6.2759C3.31929 5.12033 4.25611 4.18351 5.41644 4.18351C6.57201 4.18351 7.50883 5.12033 7.50883 6.2759C7.50883 7.42672 6.57201 8.36829 5.41644 8.36829ZM20.748 21.5741H17.1386V15.9247C17.1386 14.5789 17.1148 12.8432 15.2602 12.8432C13.3818 12.8432 13.0965 14.3126 13.0965 15.8296V21.5741H9.49185V9.95185H12.9538V11.5402H13.0014C13.4817 10.6271 14.661 9.66177 16.4158 9.66177C20.0727 9.66177 20.748 12.068 20.748 15.1971V21.5741Z",
    fill: "#290064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2612_19612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3478,
    height: 24.3478,
    fill: "white",
    transform: "translate(0 0.826172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.6850afeee3314ef3e890a278b83bb2ce.svg";
export { ForwardRef as ReactComponent };